module.exports = __webpack_public_path__ + "static/media/animalCiclo5.e95c26e0.png";